import { render, staticRenderFns } from "./FormThuxHorizontalDuration.vue?vue&type=template&id=f7d1f2aa&"
import script from "./FormThuxHorizontalDuration.vue?vue&type=script&lang=js&"
export * from "./FormThuxHorizontalDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports